/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
// import axios from "axios";

import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
import VisibilityIcon from '@material-ui/icons/Visibility';
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Button from "components/CustomButtons/Button.js";
import { localApi, credentials } from "utils/headApi";
// import Slide from "@material-ui/core/Slide";
// import Tooltip from "@material-ui/core/Tooltip";
// import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
// import Table from "components/Table/Tables.js";
import Tables from "components/Table/Table.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyl = makeStyles(aboutUsStyle);

export default function MyOrder({ ...rest }) {
  const [ordersList, setOrdersList] = React.useState([]);
  // const [userId, setUserId] = React.useState("");
  const [load, setLoad] = React.useState(false);

  const classes = useStyles();
  const history = useHistory();

  // const classesTable = useStylesTable();
  // const classeCart = useStyleCart();
  const classeTitel = useStyl();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .format(new Date())
    .replaceAll("/", "-");

  const current = new Date();
  const dateCurrent = `${current.getDate()}-${current.getMonth() + 1
    }-${current.getFullYear()}`;
  current.setDate(current.getDate() + 10);
  let dateEx = new Date(current).toLocaleDateString("de");

  async function getList() {
    const response = await fetch(localApi + `/clientGroup/allList`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const json = await response.json();
    const regClient = json.ClientList.filter((f) => f.regId == userObj.id)[0];
    // console.log(regClient);

    const getList = await fetch(
      localApi +
      `/orders/list/byAdminAndClientId/${userObj.admin.id}/${regClient.id}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    }
    );
    const res = await getList.json();
    // console.log(res);
    if (res.error === "true") {
      setLoad(false);
      history.push("/");
    } else {
      setLoad(true);
      const ress = res.filter((f) => f.cancelOrders != true)
      setOrdersList(res && ress.length != 0 ? ress : history.push("/"));
    }
  }

  useEffect(() => {
    getList();
  }, []);

  return (
    <div>
      <Helmet>
        <title>My Orders Lists</title>
      </Helmet>
      {load ? (
        <>
          <InshaHeader
            brand="Home"
            links={<InshaHeaderLink dropdownHoverColor="dark" />}
            fixed
            color="dark"
            // color="transparent"
            // changeColorOnScroll={{
            //   height: 100,
            //   color: "dark",
            // }}
          />
          <Parallax
            image={require("assets/img/My-Order.jpg").default}
            // filter="dark"
            className={classes.parallax}
          >
            <div className={classeTitel.container}>
              <GridContainer>
                <GridItem
                  md={8}
                  sm={8}
                  className={classNames(
                    classeTitel.mlAuto,
                    classeTitel.mrAuto,
                    // classeTitel.textCenter
                  )}
                >
                  <h1 className={classeTitel.title} style={{ color: "black" }}>My Orders Lists</h1>
                  <h4></h4>
                </GridItem>
              </GridContainer>
            </div>
          </Parallax>

          <div
            className={classes.container}
          // style={{ marginTop: "2%" }}
          >
            <GridContainer>
              {ordersList && ordersList.map((c, index) => (
                <GridItem xs={12} sm={4} md={4} key={index}>
                  <Card>
                    <CardBody>
                      {/* KEY–VALUE SECTION */}
                      <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                        {c.adminCompany != null ?
                          <span style={{ fontWeight: "bold" }}>
                            {c.adminCompany}
                          </span> : ""}
                        {c.adminCity != null && c.adminState != null ?
                          <span>
                            {c.adminCity + ", " + c.adminState}
                          </span> : ""}
                        <span style={{ fontWeight: "bold" }}>
                          {c.transbranch.company}
                        </span>
                        <span>
                          {c.transbranch.city + ", " + c.transbranch.state}
                        </span>
                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>SR/Order No.:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>{index + 1} / {c.id}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Date:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>{c.createDate.slice(0, -19)}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Units:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>{c.totalBox}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Cartoon:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>{c.totalCarton}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Bill Amount:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>₹ {Math.round(c.amount)}/-</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Payment:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>₹ {Math.round(c.payment.reduce((s, p) => s + p.received, 0)) + "/-"}</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Balance Amount:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>₹ {Math.round(c.balance)}/-</span>
                        </div>

                        <div style={{ display: "flex" }}>
                          <span style={{ width: "40%" }}>Status:</span>
                          <span style={{ width: "60%", fontWeight: "bold" }}>
                            {(
                              (c.payment.reduce((a, b) => a + b.received, 0) / c.amount) * 100
                            ).toFixed(2)}
                            %
                          </span>
                        </div>
                      </div>

                      {/* BUTTONS IN ONE ROW */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "15px",
                          gap: "10px",
                        }}
                      >
                        <Button
                          color="rose"
                          style={{ padding: "4px 10px", minWidth: "80px" }}
                          onClick={() => {
                            const url =
                              c.gstCash === true
                                ? localApi + `/orders/list/byAdminAndClientAndOrderIdAndInvoicePdfDownload/${userObj.admin.id}/${c.clientId}/${c.id}?cancel=0`
                                : localApi + `/orders/list/byAdminAndClientAndOrderIdAndCashBillPdfDownload/${userObj.admin.id}/${c.clientId}/${c.id}`;
                            window.open(url, "_blank");
                          }}
                        >
                          {c.gstCash === true ? "Invoice" : "Cash"}
                        </Button>

                        <Button
                          color="rose"
                          style={{ padding: "4px 10px", minWidth: "80px" }}
                          onClick={() => {
                            // history.push(`/order-view?id=${c.id}&client=${c.clientId}`)
                            const url = localApi + `/orders/list/byAdminAndClientAndOrderIdAndQuatationPdfDownload/${userObj.admin.id}/${c.clientId}/${c.id}`
                            window.open(url, "_blank");
                          }}
                        >
                          Quotation
                        </Button>

                        <Button
                          color="rose"
                          style={{ padding: "4px 10px", minWidth: "80px" }}
                          onClick={() => {
                            history.push(`/payment-recieved?id=${c.id}&client=${c.clientId}`);
                          }}
                        >
                          Pay Now
                        </Button>
                      </div>
                    </CardBody>

                  </Card>
                </GridItem>
              ))}
            </GridContainer>
          </div>

          <Footer />
        </>
      ) : (
        ""
      )}
    </div>
  );
}
